import React from 'react'
import { useEffect, useRef, useState, createRef } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import config from './config'
import { useParams } from 'react-router-dom'
import { refundApplyLogList, httpCompanyList } from '@/services/fmsServices'
import { findAuditPassResponseListByPage } from '@/services/fmsConfig'
import WhiteListApprove from '@/components/WhiteListApprove'
export default function PaymentServiceManage(props: any) {
  console.log(props)
  const listRef = useRef<any>()
  const [showApproverSubmit, setShowApproverSubmit] = useState(false);
  const [whiteId, setWhiteId] = useState('');
  const { id, orderId } = useParams()
  // 表格加载
  const fetchList = (values: any) => {
    const { current, pageSize, ...rest } = values
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values
        query.orderId = orderId
        findAuditPassResponseListByPage(current, pageSize, query).then(res => {
          resolve(res)
        })
      } catch (e) {
        reject({ success: false })
      }
    })
  }
  const getStatusOptions = () => {
    return new Promise(async resolve => {
      resolve({
      })
    })
  }
  const onAddOrEdit = (record: any) => { 
    setWhiteId(record.id)
    setShowApproverSubmit(true)
  }
  const onAdd = () => { 
    setWhiteId('')
    setShowApproverSubmit(true)
  }
  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };
  // 右侧表格配置
  const extension = {
    request: { fetchList, getStatusOptions },
    events: {onAdd},
    customRender: {
      actionRender(_: null, record: Record<string, any>) {
        return <STableActions>
          <SActionBtn onClick={() => onAddOrEdit(record)}>查看</SActionBtn>
        </STableActions>
      },
      nodeNameListName(list) {
        return list.join(',');
      },
      receiptTypeNameListName(list) {
        return list.join(',');
      },
    },
  }
  return (
    <div>
      <SLowcodeList config={config} ref={listRef} {...extension} searchMode="group" />
      <WhiteListApprove
        title={whiteId ? '收款白名单查看':'收款白名单审批'}
        open={showApproverSubmit}
        id={whiteId} //查看时需要传入id
        orderId={orderId}
        onClose={() => setShowApproverSubmit(false)}
        reload={() => { 
          reloadFn(); 
        }}
      />
    </div>
  )
}
